import axios from 'axios'
import { getLocalAccessToken } from '../services/localStorage';
import { endpoints, getFileHeaders, getAuthorizationHeaders } from './apiConfig';
import { User, Category, BodySize, BodyShape, FittingSize, FittingType, ConnTypeBodySize, MeasuringUnit, DataVersion, ProductType, UpdateSetting, NutShape, NutMaterial, Nut, OrificeSize, OrificeConfig, BodySizeConfig, ConnTypeSubComp, ConnectionConversion } from './model';

const baseUrl = process.env.REACT_APP_API_ENDPOINT;
// const baseUrl = 'http://localhost:3000/';

export async function getUserInfo(url: string): Promise<any> {
  let authorization_header = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + getLocalAccessToken(),
    }
  }

  const response = await axios.get<any>(url, authorization_header);
  return response.data;
}

export async function getAccessToken(url: string): Promise<any> {
  const response = await axios.post<any>(url, {}, {
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    }
  });
  return response.data;
}

export async function fetchSingleUser(user_sgid: string): Promise<User[]> {
  const response = await axios.get<any>(baseUrl + endpoints.user + "/sgid/" + user_sgid, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function fetchUsers() { /* : Promise<User[]> */
  const response = await axios.get<any>(baseUrl + endpoints.user, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function createUser(Users: User) {
  const response = await axios.post<User>(baseUrl + endpoints.user, Users, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function updateUser(Users: User, id: number) {
  const response = await axios.patch<User>(baseUrl + endpoints.user + "/" + id, Users, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function deleteUser(id: number) {
  await axios.delete<User>(baseUrl + endpoints.user + "/" + id, { headers: getAuthorizationHeaders() });
}

/* *****************************  Body Size code **************************** */

export async function fetchBodySizes(): Promise<BodySize[]> {
  const response = await axios.get<any>(baseUrl + endpoints.body_size, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function createBodySize(BodySizes: any) {
  const response = await axios.post<any>(baseUrl + endpoints.body_size + "/bulk", BodySizes, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function updateBodySize(BodySizes: BodySize, id: number) {
  const response = await axios.patch<BodySize>(baseUrl + endpoints.body_size + "/" + id, BodySizes, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function deleteBodySize(id: number) {
  await axios.delete<BodySize>(baseUrl + endpoints.body_size + "/" + id, { headers: getAuthorizationHeaders() });
  // await axios.delete<User>(baseUrl + endpoints.user + "/" + id, {headers : getAuthorizationHeaders()});
}

/* *****************************  Body Size code end **************************** */


/* *****************************  Body Size config **************************** */

export async function fetchBodySizeConfigs(): Promise<BodySizeConfig[]> {
  const response = await axios.get<any>(baseUrl + endpoints.body_size_config, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function createBodySizeConfig(BodySizeConfigs: any) {
  const response = await axios.post<any>(baseUrl + endpoints.body_size_config + "/bulk", BodySizeConfigs, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function updateBodySizeConfig(BodySizeConfigs: BodySizeConfig, id: number) {
  const response = await axios.patch<BodySizeConfig>(baseUrl + endpoints.body_size_config + "/" + id, BodySizeConfigs, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function deleteBodySizeConfig(id: number) {
  await axios.delete<BodySizeConfig>(baseUrl + endpoints.body_size_config + "/" + id, { headers: getAuthorizationHeaders() });
}

/* *****************************  Body Size config code end **************************** */


/* *****************************  Category code**************************** */
export async function fetchCategory(): Promise<Category[]> {
  const response = await axios.get<any>(baseUrl + endpoints.category, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function createCategory(CategoryData: Category) {
  const response = await axios.post<Category>(baseUrl + endpoints.category, CategoryData, { headers: getFileHeaders() });
  return response.data;
}

export async function updateCategory(CategoryData: Category, id: number) {
  const response = await axios.put<Category>(baseUrl + endpoints.category + "/" + id, CategoryData, { headers: getFileHeaders() });
  return response.data;
}

export async function updateCatDisabled(CategoryData: Category, id: number) {
  const response = await axios.patch<Category>(baseUrl + endpoints.category + "/" + id, CategoryData, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function deleteCategory(id: number) {
  const response = await axios.delete<Category, any>(baseUrl + endpoints.category + "/" + id, { headers: getAuthorizationHeaders() });
  return response.data;
}
/* *****************************  Category code end **************************** */
/* *****************************  BodyShape code **************************** */

export async function fetchBodyShape(): Promise<BodyShape[]> {
  const response = await axios.get<any>(baseUrl + endpoints.body_shape, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function createBodyShape(BodyShapeData: BodyShape) {
  const response = await axios.post<BodyShape>(baseUrl + endpoints.body_shape, BodyShapeData, { headers: getFileHeaders() });
  return response.data;
}

export async function updateBodyShape(BodyShapeData: BodyShape, id: number) {
  const response = await axios.put<BodyShape>(baseUrl + endpoints.body_shape + "/" + id, BodyShapeData, { headers: getFileHeaders() });
  return response.data;
}

export async function updateBodyShapeDisabled(BodyShapeData: BodyShape, id: number) {
  const response = await axios.patch<BodyShape>(baseUrl + endpoints.body_shape + "/" + id, BodyShapeData, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function deleteBodyShape(id: number) {
  const response = await axios.delete<BodyShape>(baseUrl + endpoints.body_shape + "/" + id, { headers: getAuthorizationHeaders() });
  return response.data;
}
/* *****************************  BodyShape code end **************************** */

export async function fetchFittingSizes(): Promise<FittingSize[]> {
  const response = await axios.get<any>(baseUrl + endpoints.fitting_size, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function createFittingSize(FittingSizeData: FittingSize) {
  const response = await axios.post<FittingSize>(baseUrl + endpoints.fitting_size, FittingSizeData, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function updateFittingSize(FittingSizeData: FittingSize, id: number) {
  const response = await axios.patch<FittingSize>(baseUrl + endpoints.fitting_size + "/" + id, FittingSizeData, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function deleteFittingSize(id: number) {
  await axios.delete<FittingSize>(baseUrl + endpoints.fitting_size + "/" + id, { headers: getAuthorizationHeaders() });
}

export async function checkFittingSizeExist(FittingSizeData: FittingSize) {
  const response = await axios.post<FittingSize>(baseUrl + endpoints.fitting_size + "/data_exist", FittingSizeData, { headers: getAuthorizationHeaders() });
  return response.data;
}

/* ************************************ Fitting(connection) Type code starts **********************************  */

export async function fetchFittingTypes(): Promise<FittingType[]> {
  const response = await axios.get<any>(baseUrl + endpoints.connection_type, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function createFittingType(FittingTypeData: FittingType) {
  const response = await axios.post<FittingType>(baseUrl + endpoints.connection_type, FittingTypeData, { headers: getFileHeaders() });
  return response.data;
}

export async function updateFittingType(FittingTypeData: FittingType, id: number) {
  const response = await axios.put<FittingType>(baseUrl + endpoints.connection_type + "/" + id, FittingTypeData, { headers: getFileHeaders() });
  return response.data;
}

export async function deleteFittingType(id: number) {
  await axios.delete<FittingType>(baseUrl + endpoints.connection_type + "/" + id, { headers: getAuthorizationHeaders() });
}


/* ************************************ Fitting(connection) Type code ends **********************************  */


export async function createConnTypeBodySize(dataBs: any) {
  const response = await axios.post<any>(baseUrl + endpoints.conn_type_body_size, dataBs, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function fetchConnTypeBSByConnSizeID(id: number) {
  const response = await axios.get<any>(baseUrl + endpoints.conn_type_body_size + "/" + id, { headers: getAuthorizationHeaders() });
  return response.data;
}


export async function updateConnTypeBodySize(data: ConnTypeBodySize, id: number) {
  const response = await axios.put<ConnTypeBodySize>(baseUrl + endpoints.conn_type_body_size + "/" + id, data, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function deleteConnTypeBodySize(id: number) {
  await axios.delete<ConnTypeBodySize>(baseUrl + endpoints.conn_type_body_size + "/" + id, { headers: getAuthorizationHeaders() });
}


export async function updateSubComponent(data: ConnTypeSubComp, id: number) {
  const response = await axios.put<ConnTypeSubComp>(baseUrl + endpoints.conn_type_body_size + "/SubComp/" + id, data, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function addSubComponent(data: ConnTypeSubComp) {
  const response = await axios.post<ConnTypeSubComp>(baseUrl + endpoints.conn_type_body_size + "/SubComp/", data, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function SubCompByConnTypeID(id: number) {
  const response = await axios.get<any>(baseUrl + endpoints.conn_type_body_size + "/SubComp/" + id, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function deleteSubComp(id: number, con_type_id: number) {
  const response = await axios.delete<ConnTypeBodySize>(baseUrl + endpoints.conn_type_body_size + "/SubComp/" + id + "/" + con_type_id, { headers: getAuthorizationHeaders() });
  return response.data;

}



export async function fetchMeasureUnit(): Promise<MeasuringUnit[]> {
  const response = await axios.get<any>(baseUrl + endpoints.measuring_unit, { headers: getAuthorizationHeaders() });
  return response.data;
}


export async function createConnTypeConnSize(data: any) {
  const response = await axios.post<any>(baseUrl + endpoints.conn_type_conn_size, data, { headers: getFileHeaders() });
  return response.data;
}

export async function updateConnTypeConnSize(data: any, id: number) {
  const response = await axios.put<any>(baseUrl + endpoints.conn_type_conn_size + "/" + id, data, { headers: getFileHeaders() });
  return response.data;
}

export async function fetchConnTypeConnSizeById(id: number) {
  const response = await axios.get<any>(baseUrl + endpoints.conn_type_conn_size + "/" + id, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function deleteConnTypeConnSize(id: number) {
  await axios.delete<any>(baseUrl + endpoints.conn_type_conn_size + "/" + id, { headers: getAuthorizationHeaders() });
}

/* ******************** data version code  ************************************** */

export async function fetchDataVersions(): Promise<DataVersion[]> {
  const response = await axios.get<any>(baseUrl + endpoints.data_version+'?sort=id,DESC', { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function createDataVersion(DataVersions: DataVersion) {
  const response = await axios.post<DataVersion>(baseUrl + endpoints.data_version, DataVersions, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function updateDataVersion(DataVersions: DataVersion, id: number) {
  const response = await axios.patch<DataVersion>(baseUrl + endpoints.data_version + "/" + id, DataVersions, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function deleteDataVersion(id: number) {
  await axios.delete<DataVersion>(baseUrl + endpoints.data_version + "/" + id, { headers: getAuthorizationHeaders() });
}


/* ******************** data version code endss ************************************** */

/* ************************ product type code starts ********************************* */


export async function fetchProductTypes(): Promise<ProductType[]> {
  const response = await axios.get<any>(baseUrl + endpoints.product_type + '?sort=created_datetime,ASC', { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function createProductType(ProductType: ProductType) {
  const response = await axios.post<any>(baseUrl + endpoints.product_type, ProductType, { headers: getAuthorizationHeaders() });
  return response.data;
}


export async function createProductType1(ProductTypes: ProductType) {
  const response = await axios.post<any>(baseUrl + endpoints.product_type, ProductTypes, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function updateProductType(ProductTypes: ProductType, id: number) {
  const response = await axios.patch<ProductType>(baseUrl + endpoints.product_type + "/" + id, ProductTypes, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function deleteProductType(id: number) {
  await axios.delete<ProductType>(baseUrl + endpoints.product_type + "/" + id, { headers: getAuthorizationHeaders() });
}


/* ************************ product type code starts ********************************* */


/* ************************ UpdateSetting code starts ********************************* */


export async function fetchUpdateSettings(): Promise<UpdateSetting[]> {
  const response = await axios.get<any>(baseUrl + endpoints.app_update_setting, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function createUpdateSetting(UpdateSetting: UpdateSetting) {
  const response = await axios.post<any>(baseUrl + endpoints.app_update_setting, UpdateSetting, { headers: getAuthorizationHeaders() });
  return response.data;
}


export async function updateUpdateSetting(UpdateSettings: UpdateSetting, id: number) {
  const response = await axios.patch<UpdateSetting>(baseUrl + endpoints.app_update_setting + "/" + id, UpdateSettings, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function deleteUpdateSetting(id: number) {
  await axios.delete<UpdateSetting>(baseUrl + endpoints.app_update_setting + "/" + id, { headers: getAuthorizationHeaders() });
}


/* ************************ product type code starts ********************************* */


/* ******************** nut shape code  ************************************** */

export async function fetchNutShapes(): Promise<NutShape[]> {
  const response = await axios.get<any>(baseUrl + endpoints.nut_shape + '?sort=created_datetime,DESC', { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function createNutShape(NutShapes: NutShape) {
  const response = await axios.post<any>(baseUrl + endpoints.nut_shape, NutShapes, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function updateNutShape(NutShapes: NutShape, id: number) {
  const response = await axios.patch<NutShape>(baseUrl + endpoints.nut_shape + "/" + id, NutShapes, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function deleteNutShape(id: number) {
  await axios.delete<NutShape>(baseUrl + endpoints.nut_shape + "/" + id, { headers: getAuthorizationHeaders() });
}


/* ******************** nut shape code endss ************************************** */


/* ******************** nut material code  ************************************** */

export async function fetchNutMaterials(): Promise<NutMaterial[]> {
  const response = await axios.get<any>(baseUrl + endpoints.nut_material + '?sort=created_datetime,ASC', { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function createNutMaterial(NutMaterials: NutMaterial) {
  const response = await axios.post<NutMaterial>(baseUrl + endpoints.nut_material, NutMaterials, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function updateNutMaterial(NutMaterials: NutMaterial, id: number) {
  const response = await axios.patch<NutMaterial>(baseUrl + endpoints.nut_material + "/" + id, NutMaterials, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function deleteNutMaterial(id: number) {
  await axios.delete<NutMaterial>(baseUrl + endpoints.nut_material + "/" + id, { headers: getAuthorizationHeaders() });
}


/* ******************** nut material code endss ************************************** */


/* ******************** nut code  ************************************** */

export async function fetchNuts(): Promise<Nut[]> {
  const response = await axios.get<any>(baseUrl + endpoints.nut + '?sort=created_datetime,ASC', { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function createNut(Nuts: Nut) {
  const response = await axios.post<Nut>(baseUrl + endpoints.nut, Nuts, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function updateNut(Nuts: Nut, id: number) {
  const response = await axios.patch<Nut>(baseUrl + endpoints.nut + "/" + id, Nuts, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function deleteNut(id: number) {
  await axios.delete<Nut>(baseUrl + endpoints.nut + "/" + id, { headers: getAuthorizationHeaders() });
}


/* ******************** nut code endss ************************************** */


/* ******************** orifice code  ************************************** */

export async function fetchOrificeSizes(): Promise<OrificeSize[]> {
  const response = await axios.get<any>(baseUrl + endpoints.orifice_size + '?sort=created_datetime,ASC', { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function createOrificeSize(OrificeSizes: OrificeSize) {
  const response = await axios.post<OrificeSize>(baseUrl + endpoints.orifice_size, OrificeSizes, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function updateOrificeSize(OrificeSizes: OrificeSize, id: number) {
  const response = await axios.patch<OrificeSize>(baseUrl + endpoints.orifice_size + "/" + id, OrificeSizes, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function deleteOrificeSize(id: number) {
  await axios.delete<OrificeSize>(baseUrl + endpoints.orifice_size + "/" + id, { headers: getAuthorizationHeaders() });
}


/* ******************** orifice code endss ************************************** */

/* ************************ orifice config code starts ********************************* */

export async function fetchOrificeConfigByProdTypeID(id: number): Promise<OrificeConfig[]> {
  const response = await axios.get<any>(baseUrl + endpoints.orifice_config + "/getByProdId/" + id, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function fetchOrificeConfigs(): Promise<OrificeConfig[]> {
  const response = await axios.get<any>(baseUrl + endpoints.orifice_config, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function createOrificeConfig(OrificeConfig: OrificeConfig) {
  const response = await axios.post<any>(baseUrl + endpoints.orifice_config, OrificeConfig, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function updateOrificeConfig(OrificeConfigs: OrificeConfig, id: number) {
  const response = await axios.patch<OrificeConfig>(baseUrl + endpoints.orifice_config + "/" + id, OrificeConfigs, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function deleteOrificeConfig(id: number) {
  await axios.delete<OrificeConfig>(baseUrl + endpoints.orifice_config + "/" + id, { headers: getAuthorizationHeaders() });
}


/* ************************ orifice config code starts ********************************* */

/* ************************ connection conversion code starts ********************************* */

export async function fetchConnectionConversions(): Promise<ConnectionConversion[]> {
  const response = await axios.get<any>(baseUrl + endpoints.conn_conversion, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function createConnectionConversion(ConnectionConversion: ConnectionConversion) {
  const response = await axios.post<ConnectionConversion>(baseUrl + endpoints.conn_conversion, ConnectionConversion, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function updateConnectionConversion(ConnectionConversion: ConnectionConversion, id: number) {
  const response = await axios.patch<ConnectionConversion>(baseUrl + endpoints.conn_conversion + "/" + id, ConnectionConversion, { headers: getAuthorizationHeaders() });
  return response.data;
}

export async function deleteConnectionConversion(id: number) {
  const response = await axios.delete<ConnectionConversion, any>(baseUrl + endpoints.conn_conversion + "/" + id, { headers: getAuthorizationHeaders() });
  return response.data;
}

/* ************************ connection conversion code ends ********************************* */
